import { createSelector } from '@ngrx/store';
import { getContentEditorState, ContentEditorState } from '..';

export const getSidebarState = createSelector(getContentEditorState, (state: ContentEditorState) => state.sidebar);
